import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import StoreOrderClaimForm from './forms/StoreOrderClaimForm';
import StoreOrderClaimList from './lists/StoreOrderClaimList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {postData} from "../../utils/request";
import {isTrue} from "../../utils/other";
import PrintButton from "../form/PrintButton";

const stateTypes = {
    INITIATED_STATE: state => state + "" === "0",
    INPROGRESS_STATE: state => state + "" === "100",
    SETTLED_STATE: state => state + "" === "200",
};

const typeTypes = {
    SHORTAGE: type => type + "" === "-1",
    SURPLUS: type => type + "" === "1",
}

class StoreOrderClaimEditor extends React.Component {

    state = {
        sendClaim: false,
        newButton: false
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.setPristineValues({client_component_type: this.props.client.componentConfig.componentname, client_component_id: this.props.client.values[this.props.client.componentConfig.idfield]});
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    saveAction = async (event) => {
        await this.props.processAction(async () => {
            const data = JSON.parse(JSON.stringify(this.props.values));
            data.items = Object.values(data.items || {}).map((product) => ({product_id: product.product_id, shortage: product.shortage, surplus: product.surplus, qty: product.qty})).filter((product) => {
                return product.shortage || product.surplus;
            });
            return await postData({
                action: this.props.componentConfig.componentname + '.createAction',
                data
            });
        });
        await this.props.pristineForm(false);
        this.list && this.list.refresh();
        this.editor && this.editor.hide();
    }

    sendAction = (action) => {
        this.props.processAction(async () => {
            return await postData({
                action: this.props.componentConfig.componentname + '.' + action,
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const actionButtons = [];

        if (this.props.values[this.props.componentConfig.idfield] && stateTypes.INITIATED_STATE(this.props.values.state)) {
            actionButtons.push(
                <Button
                    key="0"
                    type="button"
                    disabled={this.props.isLoading || !this.state.sendClaim}
                    color="primary"
                    className={"pull-right"}
                    onClick={() => this.sendAction('sendClaim')}
                >
                    Mehet
                </Button>
            );
        } else if(!this.props.values[this.props.componentConfig.idfield]) {
            actionButtons.push(
                <Button
                    key="1"
                    type="button"
                    disabled={this.props.isLoading || !Object.keys(this.props.values.items || {}).length}
                    color="primary"
                    className={"pull-right"}
                    onClick={this.saveAction}
                >
                    Mentés
                </Button>
            );
        }
        if (this.props.values[this.props.componentConfig.idfield] && stateTypes.SETTLED_STATE(this.props.values.state)) {
            actionButtons.push(
                <PrintButton
                    key="2"
                    {...this.props}
                    className="pull-right"
                />
            );
        }

        const listButtons = [];

        if (this.props.newButton) {
            listButtons.push(
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            );
        }

        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Reklamációk"
                    footer={listButtons}
                >
                    <StoreOrderClaimList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                {(this.props.values[this.props.componentConfig.idfield] || this.props.client) && <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Reklamáció"
                    footer={actionButtons}
                >
                    <StoreOrderClaimForm {...this.props} typeTypes={typeTypes} stateTypes={stateTypes} setProcessSelected={(sendClaim) => this.setState({sendClaim})} sendClaim={this.state.sendClaim} />
                </Editor>}
        </Fragment>;
    }
}

export default createEditor({
    componentName: "StoreOrderClaim",
    WrappedComponent: StoreOrderClaimEditor,
    props: {
        view: "admin",
        componentActions: (action, data) => {
            data = JSON.parse(JSON.stringify(data));
            if (action === "create") {
                data.items = Object.values(data.items || {}).map((product) => ({product_id: product.product_id, shortage: product.shortage, surplus: product.surplus, qty: product.qty})).filter((product) => {
                    return product.shortage || product.surplus;
                });
            }
            return {action,data};
        }
    }
});
